import { adTypes } from './requestAd';
import createJsonAdHandler from './createJsonAdHandler';
import createHtmlAdHandler from './createHtmlAdHandler';
import createPrebidAdHandler from './createPrebidAdHandler';
import { track } from '../tracking';
import { withAdResponseReceivedEvent } from '../tracking/events';
var jsonAdHandler = createJsonAdHandler();
var htmlAdHandler = createHtmlAdHandler();
var prebidAdHandler = createPrebidAdHandler();

var handleNoAd = function handleNoAd(adSpot, _ref) {
  var _adSpot$loadCompleteC;

  var contentType = _ref.contentType;
  track(withAdResponseReceivedEvent({
    adResponseContentType: contentType,
    fcid: '-4'
  }), adSpot);
  (_adSpot$loadCompleteC = adSpot.loadCompleteCallback) === null || _adSpot$loadCompleteC === void 0 ? void 0 : _adSpot$loadCompleteC.call(adSpot, undefined, false);
  return Promise.resolve('No ad returned');
};

var renderAd = function renderAd(adSpot) {
  var handleJsonAd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : jsonAdHandler;
  var handleHtmlAd = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : htmlAdHandler;
  var handlePrebidAd = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : prebidAdHandler;
  return function (response) {
    var adType = response.adType;

    switch (adType) {
      case adTypes.NO_AD:
        return handleNoAd(adSpot, response);

      case adTypes.NATIVE:
        return handleJsonAd(adSpot, response);

      case adTypes.PREBID:
        return handlePrebidAd(adSpot, response);

      case adTypes.HTML:
        return handleHtmlAd(adSpot, response);

      default:
        return Promise.reject();
    }
  };
};

export default renderAd;
//# sourceMappingURL=renderAd.js.map